// Transform API data to component format
const transformDayWiseItinerary = (apiResponse) => {
  const { dateWiseSummary, itineraryParts } = apiResponse;
  
  if (!dateWiseSummary || !Array.isArray(dateWiseSummary)) {
    return [];
  }
  
  return dateWiseSummary.map((day, index) => {
    // Find stay for this specific date (check-in date must match)
    const dayStays = itineraryParts?.filter((p) => p.type === 'STAY' && p.startDate === day.date);
    
    // Find all activities for this specific date (startDate must match)
    const dayActivities = itineraryParts?.filter((p) => p.type === 'ACTIVITY' && p.startDate === day.date) || [];
    
    return {
      day: index + 1,
      date: formatDate(day.date),
      description: day.summary,
      stays: dayStays,
      activities: dayActivities,
    };
  });
};

// Helper function to format date
const formatDate = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      weekday: 'long',
    };
    return date.toLocaleDateString('en-US', options);
  } catch (error) {
    return dateString;
  }
};

export default transformDayWiseItinerary;
